// extracted by mini-css-extract-plugin
export default {"phoneInput":"d5c5a4bcc51dfa7b6d079a49a8a4d969-scss"};